import React from "react";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import { t } from "i18next";

interface Props {
    saleSupportLabel: string;
    saleSupport: any;
    generalSalesSupports: any[];
    translatedSaleSupport: Record<string, any>;
    displayName: string;
    isConsult: boolean;
    isNameExist: boolean;
    inputSaleSupportLabel: boolean;
    setSaleSupportLabel: (v: string) => void;
    setDisplayName: (v: string) => void;
    setAdvancedDisplayName: (v: any) => void;
    setIsEdited: (v: boolean) => void;
    advancedDisplayNameDefault: any;
    advancedDisplayName: any;
    setInputSaleSupportLabel: (v: boolean) => void;
    setInputDisplayName: (v: boolean) => void;
}

const SalesSupportSelect: React.FC<Props> = ({
    saleSupportLabel,
    saleSupport,
    generalSalesSupports,
    translatedSaleSupport,
    displayName,
    isConsult,
    isNameExist,
    inputSaleSupportLabel,
    setSaleSupportLabel,
    setDisplayName,
    setAdvancedDisplayName,
    setIsEdited,
    advancedDisplayNameDefault,
    advancedDisplayName,
    setInputSaleSupportLabel,
    setInputDisplayName,
}) => (
    <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
        <StyledLabel htmlFor="text" className="required__clz mt-3">
            {t("Sales support")}
        </StyledLabel>
        <StyledSelectInput
            isClearable
            isDisabled={saleSupport.Id !== undefined}
            options={generalSalesSupports}
            placeholder={`${t("Select")}…`}
            value={
                saleSupportLabel
                    ? { label: saleSupportLabel, value: saleSupportLabel }
                    : null
            }
            onChange={(e: any) => {
                if (e === null && displayName === "") {
                    setAdvancedDisplayName(advancedDisplayNameDefault);
                    setSaleSupportLabel("");
                } else if (e !== null) {
                    setAdvancedDisplayName({
                        ...advancedDisplayName,
                        languages: translatedSaleSupport[e.label],
                    });
                    setSaleSupportLabel(e.label);
                }
                setIsEdited(true);
                setInputSaleSupportLabel(false);
                setDisplayName(e !== null ? e.label : "");
                setInputDisplayName(false);
            }}
            className={classnames("sdv_inp_FRsalesSupport", {
                invalid__clz: inputSaleSupportLabel || isNameExist,
            })}
            noOptionsMessage={() => t("No options")}
            name={t("Sales support")}
        />
        {inputSaleSupportLabel && (
            <div className="text-danger small mt-1">
                {t("Please select a sales support")}
            </div>
        )}
        {isNameExist && (
            <div className="text-danger small mt-1">
                {t("The sale support is already exists")}
            </div>
        )}
    </AvGroup>
);

export default SalesSupportSelect;
